import React from 'react';
import { Auth, I18n } from 'aws-amplify';
import axios from 'axios';

import {authConfig} from '../../configures/awsConfig.js'
import {SESSION_INIT_URL} from '../../configures/val.js'

import {
  VerifyContact,
  AmplifyTheme,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  MessageRow,
  ButtonRow,
  Link,
} from 'aws-amplify-react';

import LogoArea from './logoarea.js';
import LapDialog from '../util/laplaceDialog.js';
import getHrefByLocaleLaplaceidQa from '../util/getHrefByLocale.js';

export default class MyVerifyContact extends VerifyContact {
  constructor(props) {
    super(props);
    this._validAuthStates = ['verifyContact'];
    this.verify = this.verify.bind(this);
    this.submit = this.submit.bind(this);
    // emailによるID作成としないのであれば変更する必要がある
    // 選択肢としてはphone_numberくらい
    this.state = {
      verifyAttr: 'email',
      open: false,
      resendErrOpen: false,
      resendErrStr: '',
      isDisabled: true,
      errorStr: '',
    };
  }
  toClose = () => {
    this.setState({
      open: false,
    });
  }
  resendErrClose = () => {
    this.setState({
      resendErrOpen: false
    });
  }

  handleInputChange(evt) {
    const { name, value } = evt.target;
    this.inputs[name] = value;
    let error = '';
    let buttonState = this.state.isDisabled;
    if (name === 'code') {
      if (value.match(/([^0-9])+/)) {
        error = I18n.get('Invalid verification code provided, please try again.');
        buttonState = true;
      } else if (value === '') {
        buttonState = true;
      } else {
        buttonState = false;
      }
      this.setState({
        errorStr: error,
        isDisabled: buttonState
      })
    }
  }
  submit() {
    const attr = this.state.verifyAttr;
    const { code } = this.inputs;
    if (!Auth || typeof Auth.verifyCurrentUserAttributeSubmit !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    Auth.signIn(this.props.authData.userData.username, this.props.authData.userData.pw).then((user) => {
      Auth.verifyCurrentUserAttributeSubmit(attr, code).then(data => {
        const urlStr = SESSION_INIT_URL+"?client_id="+authConfig.userPoolWebClientId+"&refresh_token="+user.signInUserSession.refreshToken.token;
        axios.get(
          urlStr,
          {
            headers: {
              'Content-Type': 'plain/text',
            },
            withCredentials: true,
          }
        ).then((response) => {
          this.changeState('signedIn', user);
        }).catch(err => {
          console.log(err);
          this.changeState('signedIn', user);
        });
      }).catch(err => {
        const tmp = I18n.get(err.message);
        this.setState({errorStr: tmp})
      });
    }).catch(err => {
      const tmp = I18n.get(err.message);
      this.setState({errorStr: tmp})
    });
  }

  submitView() {
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div>
      <label className="loginLabel">{I18n.get('Code')}</label>
        <InputRow
        placeholder={I18n.get('Code')}
        theme={theme}
        key="code"
        name="code"
        autoComplete="off"
        onChange={this.handleInputChange}
        />
        <p className='errorText'>{this.state.errorStr}</p>
        <div className="confirmCode">
          <ButtonRow style={theme.loginLargeButton} theme={theme} onClick={this.submit} disabled={this.state.isDisabled}>{I18n.get('Next')}</ButtonRow>
        </div>
      </div>
    )
  }
  getErrorMessage = (err) => {
    const {code, message} = err;
    if (message)
      return message;
    if (code)
      return code;
    if (typeof err === 'string')
      return err;
    return '';
  }
  resend = () => {
    Auth.signIn(this.props.authData.userData.username, this.props.authData.userData.pw).then((user) =>
      Auth.verifyCurrentUserAttribute(this.state.verifyAttr)
      .then(data => {
        this.setState({open: true});
        Auth.signOut().then();
      })
    ).catch((err)=>{
      const tmpstr = this.getErrorMessage(err);
      console.log('lap confirm resend err');
      console.log(err);
      
      this.setState({
        resendErrStr: I18n.get(tmpstr),
        resendErrOpen: true
      });
    });
  }
  showMessage = () => {
    const {username} = this.props.authData.userData;
    return(
      <div>
        <MessageRow>{username}</MessageRow>
        <MessageRow>{I18n.get('The Verification Code was sent. Enter the 6 digit verification code described in the mail body and send it.')}</MessageRow>
      </div>
    );
  }
  showComponent(theme) {
    const {username} = this.props.authData.userData;
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Confirm Sign Up')}</SectionHeader>
          <SectionBody theme={theme}>
          <div className="fontSizeSmall colNatural01">
          { username? this.showMessage()
          : <MessageRow>I18n.get('The Verification Code was sent.')</MessageRow>
          }
          { this.submitView() }
          </div>
          </SectionBody>
          <SectionFooter theme={theme}>
            <div className="loginCodecheckFooter textLeft">
              <p className="fontSizeSmall">{I18n.get('If you can not receive verification code, you can try to resend.')}<br />
                <Link theme={theme} onClick={this.resend}>
                {I18n.get('Resend Code')}
                </Link>
              </p>
              {getHrefByLocaleLaplaceidQa(theme)}
            </div>
          </SectionFooter>
        </FormSection>
        <LapDialog contentText={I18n.get('The Verification Code was resent.')} open={this.state.open} toClose={this.toClose} />
        <LapDialog contentText={this.state.resendErrStr} open={this.state.resendErrOpen} toClose={this.resendErrClose} />
      </div>
    )
  }
  }
